import LockIcon from "@/assets/icons/lockBasic/medium.svg?react"

type TNavbarNodeBase = {
  heading: string
  href: string
  isIndex?: boolean
  disabled?: boolean
  /** Not built: never rendered (not in the DOM). Unlike `disabled`, which shows the item with a lock. */
  hidden?: boolean
  externalHref?: string
}
export type TNavbarNode = TNavbarNodeBase & {
  icon: { Base: typeof LockIcon; Active: typeof LockIcon }
  children?: TNavbarNodeBase[]
}

/**
 * The nodes the sidebar and the mobile drawer actually show: hidden nodes and hidden children are
 * dropped, and a parent whose children are all hidden becomes a plain link.
 */
export const visibleNavNodes = (nodes: TNavbarNode[]): TNavbarNode[] =>
  nodes
    .filter((node) => !node.hidden)
    .map((node) => {
      if (!node.children) return node
      const children = node.children.filter((child) => !child.hidden)
      if (children.length) return { ...node, children }
      return { ...node, children: undefined }
    })

export const isNavNodeActive = (node: TNavbarNodeBase, pathname: string) =>
  node.isIndex ? pathname === node.href : pathname.startsWith(node.href)

// A parent counts as "active" both when its own href matches and when one of its children's
// hrefs does — some parent/child pairs (e.g. Scope 2 / EACs) don't share a common href prefix.
export const isNavNodeOrChildActive = (node: TNavbarNode, pathname: string) =>
  isNavNodeActive(node, pathname) || !!node.children?.some((child) => isNavNodeActive(child, pathname))
